import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit", "required"]

  connect() {
    this.validate()
  }

  validate() {
    const nativeValid = this.element.checkValidity()
    const customValid = this.requiredTargets.every((el) => {
      const value = (el.value || el.textContent || "").replace(/<p><br\s*\/?><\/p>|<p><\/p>/g, "").trim()
      return value.length > 0
    })

    const isValid = nativeValid && customValid
    this.submitTargets.forEach((button) => {
      button.disabled = !isValid
      button.classList.toggle("opacity-50", !isValid)
      button.classList.toggle("cursor-not-allowed", !isValid)
    })
  }
}
